import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	backgroundColor: {
		id: 'company-hub.carousel-extension.frame.background.color',
		defaultMessage: 'Background color',
		description: 'Text labeling a customization option for background color',
	},
	textColor: {
		id: 'company-hub.carousel-extension.frame.text.color',
		defaultMessage: 'Text color',
		description: 'Text labeling a customization option for text color',
	},
	colorValidationSuccessMessage: {
		id: 'company-hub.carousel-extension.frame.color-contrast.success',
		defaultMessage: 'Your text and background colors work well for readability.',
		description:
			'Message that informs user that their color selections meets contrast ratio accessibility standards',
	},
	colorValidationFailMessage: {
		id: 'company-hub.carousel-extension.frame.color-contrast.fail',
		defaultMessage: 'Your text and background colors don’t work well for readability.',
		description:
			'Message that informs user that their color selections does not meet contrast ratio accessibility standards',
	},
});
